import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap"
import 'notyf/notyf.min.css';

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  // Set the document title based on the route meta title, or an empty string if not set
  document.title = (to.meta.title as string) || '';

  // Get the favicon URL from the route's meta or default to '/favicon.ico'
  const favicon = (to.meta.favicon as string) || '/favicon.ico';  

  // Try to find an existing <link rel="icon"> tag or create a new one
  const link = (document.querySelector("link[rel='icon']") as HTMLLinkElement) || document.createElement('link');
  link.rel = 'icon';
  link.href = favicon;

  // Append the favicon link to the document head
  document.head.appendChild(link);

  // Proceed with the navigation
  next(); 
});

const head = createHead();
const app = createApp(App);

app.use(router);
app.use(head);
app.mount('#app');
